export const CLIENT_REFERRAL_LINK = '/internet';
